import { CAST_AI } from '@cast/constants';
import { Icons } from '@cast/design-system';
import {
  EXPIRED_TRIAL_READONLY_TOOLTIP,
  useTrial,
} from '@cast/shared-trial-ui';

import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';
import FeatureLabel from './_components/FeatureLabel';

type SetupProps = Pick<
  AgentSetupBlockProps,
  | 'checked'
  | 'onChange'
  | 'hasBeenInstalled'
  | 'readonlyTooltip'
  | 'showCheckbox'
  | 'labelChip'
>;

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.workloadAutoscaler;
const icon = <Icons.CastWorkloadAutoscaler variant="preset" weight="light" />;

export const AgentWorkloadAutoscalerSetup = ({
  labelChip,
  ...props
}: SetupProps) => {
  const { isPreTrial, isExpired } = useTrial();

  return (
    <AgentSetupBlock
      heading={heading}
      description={`Run cost-effective workloads on peak performance with ${CAST_AI}'s workload optimization.`}
      icon={icon}
      labelChip={
        labelChip ?? <FeatureLabel type={isPreTrial ? 'trial' : 'premium'} />
      }
      testId="agent-workload-autoscaler"
      readonlyTooltip={isExpired ? EXPIRED_TRIAL_READONLY_TOOLTIP : undefined}
      {...props}
      {...(isExpired ? { checked: false, readonly: true } : {})}
    />
  );
};

export const AgentWorkloadAutoscalerComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      icon={icon}
      testId="agent-workload-autoscaler-complete"
      checked={checked}
    />
  );
};
